import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import ForgetPassLeft from "../assets/login/bg-left-forgot-password.jpg";
import LogoLogin from "../assets/login/logo-round.svg";
import { resetPassword } from "../actionCreator/commonActionCreator";
import { msgEnum } from "../config";
import "../assets/css/style.css";

const ResetPassword = () => {
  const [form, setForm] = useState({ code: "", password: "" });
  const [errorObj, setError] = useState();
  const [msg, setMsg] = useState();
  const [key, setKey] = useState();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  //forgotPasswordInfo
  const resetPasswordInfo = useSelector(
    (state) => state.CommonReducer.resetPasswordInfo,
  );
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    setKey(queryParams?.get("key"));
  }, [window.location.search]);
  useEffect(() => {
    if (resetPasswordInfo && Object.keys(resetPasswordInfo).length) {
      setForm({ code: "", password: "" });
      if (resetPasswordInfo?.msg) {
        navigate("/signin");
      } else {
        setMsg(msgEnum.RESET_PASSWORD_MSG);
      }
    }
  }, [resetPasswordInfo]);

  const OnInputChange = (ele) => {
    setForm({
      ...form,
      [ele.target.name]: ele.target.value,
    });
  };

  const validateForm = () => {
    let errObj;
    let errCnt = false;
    errObj = {
      ...errObj,
      error: "",
    };
    if (!form?.password) {
      errCnt = true;
      errObj = {
        ...errObj,
        password: "Please enter password.",
      };
    }
    setError(errObj);
    if (!errCnt) {
      const payload = { key: key, newPassword: form?.password };
      dispatch(resetPassword(payload));
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      validateForm();
    }
  };
  return (
    <>
      <div style={{ margin: 20 }}>
        <NavLink to={"/"}>
          <img src={LogoLogin} />
        </NavLink>
      </div>
      <div className="logincontainer">
        <div className="layer">
          <div className="main-agile1">
            <div className="main-agile">
              <div className="alert-close"> </div>
              <div>
                <NavLink to={"/"}>
                  <img src={ForgetPassLeft} alt="Go back to Home Page" />
                </NavLink>
              </div>
              <div className="content-wthree">
                <h2>Welcome! User</h2>
                <h4>
                  Not yet registered? Please{" "}
                  <NavLink to={"/signup"}>Register</NavLink> now.
                </h4>
                <div className="bottom-w3l">
                  <p>Need any assistance? </p>
                  <p>
                    <strong>Call +91-901-573-1800</strong>
                  </p>
                </div>
              </div>
            </div>

            <div className="w3layouts-main">
              <i className="fa fa-lock" aria-hidden="true"></i>
              <h2>Reset Password</h2>
              <br />
              <br />
              <form>
                <div className="email">
                  <div className="error">{msg}</div>
                  <input
                    className="passw"
                    placeholder="New Password*"
                    name="password"
                    type="password"
                    value={form?.password}
                    required=""
                    onChange={OnInputChange}
                  />
                  <span className="icons i2">
                    <i className="fa fa-unlock" aria-hidden="true"></i>
                  </span>

                  <div className="error">{errorObj?.password}</div>
                </div>
                {/* <input type="button" value="Submit" name="submit"/> */}
                <input
                  type="button"
                  value="Submit"
                  name="submit"
                  onClick={validateForm}
                  onKeyPress={handleKeyPress}
                />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />

                <h7>
                  Already have an account?{" "}
                  <NavLink to={"/signin"}>Login</NavLink>
                </h7>
              </form>
            </div>

            <div className="clear"></div>
          </div>
          <div className="footer-w3l">
            <p className="agileinfo">
              {" "}
              © 2023 Beyond Leadz. All rights reserved. Design by{" "}
              <a href="http://techfreedomonline.com/" target="_blank">
                Tech Freedom Online
              </a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
export default ResetPassword;
